
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Document, IconsType } from "@/types";
import { mdiPaperclip } from "@mdi/js";
const ItemModule = namespace("ItemModule");
const AppModule = namespace("AppModule");
const size = 2 * 1024 * 1024;
const sizeText = "2 MiB";
@Component({
  components: {
    LabelDocument: () => import("@/components/Label/LabelDocument.vue")
  }
})
export default class StepperTemplateUpload extends Vue {
  @ItemModule.State
  public signedTemplate!: Document;
  @AppModule.Getter
  public smallScreen!: string;
  private truncateLength = 15;
  private uploading = false;
  private valid = false;
  private fileInputId = "file-input-template";
  private template: File | null = null;
  private accept = "application/pdf";
  private rules = [
    (t: File) => {
      if (!t) return true;
      if (t.type === this.accept) return true;
      else return this.$t("pages.item.stepper.rules.type-template");
    },
    (t: File) => {
      if (!t) return true;
      if (t.size <= size) return true;
      else return this.$t("pages.item.stepper.rules.size", { s: sizeText });
    }
  ];
  private icons: IconsType = {
    file: mdiPaperclip
  };
  async removeTemplate() {
    await this.$store.dispatch(
      "ItemModule/deleteDocument",
      this.signedTemplate.id
    );
    this.$store.commit("ItemModule/SIGNED_TEMPLATE", null);
  }
  upload() {
    this.uploading = true;
    setTimeout(async () => {
      if (this.valid) {
        if (this.signedTemplate) await this.removeTemplate();
        const res = await this.$store.dispatch(
          "ItemModule/uploadTemplate",
          this.template
        );
        if (!res) this.$emit("error");
        else this.template = null;
      }
      this.uploading = false;
    }, 0);
  }
  public onPrependInnerClick() {
    document.getElementById(this.fileInputId)?.click();
  }
}
